import { createSignal } from "solid-js";
import { closeGptPopOver } from "../ui/ChatGptPopOver";

type ShowChatGpt = {
	assistaint: boolean;
	dialogue: boolean;
};
export const ChatGptModes = {
	Close: {
		assistaint: false,
		dialogue: false
	}
} as const;

export const [getIsShowChatGpt, setIsShowChatGpt] = createSignal<ShowChatGpt>({
	assistaint: false,
	dialogue: true
});

export const setIsChatGptVisible = (state: ShowChatGpt) => {
	setIsShowChatGpt(state);
	closeGptPopOver();
};

export const getIsChatGptVisible = () => {
	return getIsShowChatGpt().assistaint || getIsShowChatGpt().dialogue;
};
